<template>
  <div class="vote--page">
    <div class="main">
      <div class="title">
        <div class="title-text">
          {{$route.query.title || title}}
        </div>
        <div class="title-time">
          截止时间（{{endTime}}）
          <!-- <br>
          {{startTime}}-{{endTime}} -->
        </div>
      </div>
      <div class="total" v-if="false">
        <span class="vote">
          <span>访问数:</span>
          <span class="num">{{votesTotal}}</span>
        </span>
        <span class="sign-up">
          <span>报名数:</span>
          <span class="num">{{totalNumber}}</span>
        </span>
      </div>
      <div class="search">
        <input style="border-bottom: 1px solid #efefef; width: 100%;"  @focus="handleSearchFocus" v-model="searchQ" placeholder="输入名称或编号" /> <span @click="searchQ = ''">清空</span>
        <!-- <input v-model="searchQ" type="text" placeholder="输入名称或编号"/> <span @click="searchQ = ''">清空</span> -->
      </div>
      <nut-infiniteloading
        @loadmore="handleReachBottom"
        :is-show-mod="true"
        :has-more="!pageEnd"
        :is-loading="isLoading"
        :use-window="true"
        :threshold="20" class="list">
        <voteCard @showDownload="dialogShow = true" @voteNumberPlus="votesTotal++" :index="searchQ ? '' : (index + 1)" :cardData="item" v-for="(item, index) in list" :key="index"></voteCard>
      </nut-infiniteloading>
      <div class="bottom-wrap">
        <div class="bottom-main">
          <div class="share" @click="handleShare" v-if="loginFlag">
            <i class="icon-share iconfont"></i>
            <span class="text">分享</span>
          </div>
          <div class="big-button">
            <div class="rules" @click="seeRules">规则</div>
            <div class="apply" v-if="signUp === 0" @click="goApply">报名</div>
          </div>
        </div>
      </div>
    </div>
    <nut-popup :style="{ padding: '30px 24px', borderRadius: '8px', width: '6rem' }" :round="true" :closeable="true" v-model="showPop">
      <div class="toast-title">规则</div>
      <div class="toast-main">
        <template v-if="activityDescription">
          <div class="line">{{activityDescription}}</div>
        </template>
        <template>
          <div class="line">1、每成功支持1次可使支持数加1</div>
          <div class="line">2、每个用户每30分钟可以投一票</div>
        </template>
      </div>
    </nut-popup>
    <nut-dialog title="提示" :visible="dialogShow" @ok-btn-click="dialogShow=false" cancelBtnTxt="关闭" :noOkBtn="true" @cancel-btn-click="dialogShow=false" @close="dialogShow=false">
      <div class="tip-main">投票或报名，请扫描二维码或点击下方链接，下载环保小智，在环保小智中进行操作</div>
      <img src="https://image.qsyhbgj.com/img-download-page.png" alt="">
      <a @click="$router.push('/h5download')" href="javascript:;" :noCancelBtn="true">或点击下载</a>
    </nut-dialog>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import voteCard from '@/components/vote/voteCard'
// import qs from 'qs'
import api from '../../api/index'

export default {
  data () {
    return {
      startTime: '',
      endTime: '',
      activityDescription: '',
      showPop: false,
      searchQ: '',
      value: '',
      list: [],
      signUp: false,
      pageNo: 1,
      pageEnd: false,
      isLoading: false,
      votesTotal: 0,
      totalNumber: 0,
      loginFlag: Boolean(this.$route.query.token),
      dialogShow: false,
      title: ''
    }
  },
  mounted () {
    const classaList = this.$route.query.classa && this.$route.query.classa.split(',')
    !this.$route.query.title && api.getVoteMenus().then(res => {
      res.data.forEach(item => {
        if (item.id === +classaList[0]) {
          item.child.forEach(item1 => {
            if (item1.id === +classaList[1]) {
              this.title = item1.name
            }
          })
        }
      })
    })
  },
  activated () {
    document.title = '企业排名'
  },
  methods: {
    downloadTip () {
      if (!this.loginFlag) {
        this.dialogShow = true
        return true
      }
      return false
    },
    seeRules () {
      this.showPop = true
    },
    goApply () {
      if (this.downloadTip()) return false
      this.$router.push('/h5vote-apply?classa=' + this.$route.query.classa + '&title=' + this.$route.query.title)
    },
    scrollToPosition (target) {
      window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame
      const el = document.documentElement || document.body
      if (window.requestAnimationFrame) {
        requestAnimationFrame(function fn () {
          var oTop = el.scrollTop
          if (target - oTop < 1 && target - oTop > -1) {
            el.scrollTop = target
          } else {
            el.scrollTop = (oTop + Math.ceil((target - oTop) / 6))
            requestAnimationFrame(fn)
          }
        })
      } else {
        el.scrollTop = target
      }
    },
    handleSearchFocus () {
      // this.scrollToPosition(328)
    },
    search () {
      this.handleReachBottom(true)
    },
    handleReachBottom (refresh) {
      if (refresh) {
        this.pageNo = 1
        this.list = []
        this.pageEnd = false
      }
      let tmpParams
      let tmpPromise
      if (this.searchQ) {
        if (!this.$route.query.classa) return
        tmpParams = {
          name: this.searchQ,
          pages: 20,
          pageNo: this.pageNo,
          classa: this.$route.query.classa
        }
        tmpPromise = api.getVoteSearch
      } else {
        if (!this.$route.query.id) return
        tmpParams = {
          pages: 20,
          pageNo: this.pageNo,
          classaId: this.$route.query.id
        }
        tmpPromise = api.getVoteList
      }
      this.isLoading = true
      tmpPromise(tmpParams).then(res => {
        this.isLoading = false
        if (res.data && res.data.list) {
          this.pageNo++
          this.list = [...this.list, ...res.data.list]
          this.pageEnd = (this.list.length >= res.data.totalNumber) || this.pageNo === 3
          res.data.votesTotal && (this.votesTotal = res.data.votesTotal)
          res.data.totalNumber && (this.totalNumber = res.data.totalNumber)
          this.signUp = res.data.signUp
          this.startTime = res.data.startTime
          this.endTime = res.data.endTime
          this.activityDescription = res.data.activityDescription
        }
      })
    },
    handleShare () {
      if (uni) {
        uni.postMessage({
          data: {
            type: 'iframeShare',
            path: `#/h5vote?id=${this.$route.query.id}&classa=${this.$route.query.classa}&title=${this.$route.query.title || this.title}`
          }
        })
      } else {
        window.parent.postMessage({ type: 'iframeShare', path: `h5vote?id=${this.$route.query.id}&classa=${this.$route.query.classa}&title=${this.$route.query.title}` }, '*')
      }
    }
  },
  watch: {
    searchQ () {
      console.log(111)
      this.search()
    },
    '$route.query.id': {
      handler () {
        this.handleReachBottom(true)
        window.parent.postMessage({ type: 'iframeLoaded' }, '*')
      },
      immediate: true
    }
  },
  components: {
    voteCard
  }
}
</script>

<style lang="scss">
.vote--page {
  display: flex;
  flex-direction: column;
  background: #94A4A5 url('https://image.qsyhbgj.com/img-vote-bc.png') no-repeat;
  background-attachment: fixed;
  background-position: bottom;
  min-height: 100%;
  .main {
    padding-bottom: 44px;
    background: #f4f5f6;
    width: 7.5rem;
    margin: 0 auto;
    min-height: 100vh;
    .title {
      font-weight: bold;
      height: 180px;
      // text-shadow: 0px 1px 8px #111;
      padding: 12px;
      color: #fff;
      background: url('https://image.qsyhbgj.com/img-vote-back.jpeg') no-repeat center center;
      position: relative;
      .title-text {
        font-size: 28px;
        color: #B2020A;
        // color: #fff;
        // background: #C5DFF8;
        text-shadow: 1px 1px 12px #666;
        text-align: center;
        position: absolute;
        width: 100%;
        padding: 12px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      .title-time {
        position: absolute;
        bottom: 0;
        text-shadow: 0px 0px 12px #333;
        right: 12px;
      }
    }
    .total {
      background: #fff;
      display: flex;
      align-items: center;
      .vote, .sign-up {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: 12px;
        .num {
          font-size: 24px;
          font-weight: bold;
          color: #164aaf;
          line-height: 1;
        }
      }
    }
    .search {
      display: flex;
      padding: 12px;
      position: sticky;
      top: 0px;
      z-index: 10;
      background: #f4f5f6;
      display: flex;
      span {
        flex: 0 0 auto;
        line-height: 32px;
        padding: 0 8px;
        cursor: pointer;
      }
      input {
        flex: 1;
        margin-right: 4px;
        border: 0;
        border-radius: 4px;
        padding: 0 4px;
        &:focus {
          outline: 0;
          border: 0;
        }
      }
    }
    .list {
      .vote-card--com {
        margin-bottom: 0;
      }
      .tips-txt {
        color: #83889a;
      }
    }
    .bottom-wrap {
      position: fixed;
      bottom: 0;
      left: 50%;
      width: 7.5rem;
      transform: translate(-50%);
      background: #fff;
      .bottom-main {
        display: flex;
        background: #fff;
        align-items: center;
        width: 7.5rem;
        margin: 0 auto;
        padding: 6px 12px;
        border-top: 1px solid #efefef;
        .share {
          margin-right: 12px;
          display: flex;
          line-height: 1;
          flex-direction: column;
          cursor: pointer;
          .text {
            margin-top: 2px;
            font-size: 12px;
          }
        }
        .big-button {
          flex: 1;
          display: flex;
          border-radius: 4px;
          overflow: hidden;
          cursor: pointer;
          .rules, .apply {
            flex: 1;
            text-align: center;
            line-height: 44px;
            height: 44px;
            color: #fff;
          }
          .rules {
            background: linear-gradient(70deg,#eb934c,#d67946);
          }
          .apply {
            background: linear-gradient(70deg,#376dd6,#1b50b6);
          }
        }
      }
    }
  }
  .toast-title {
    text-align: center;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #efefef;
  }
  .toast-main {
    color: #333;
    font-size: 14px;
  }
  .nut-dialog-content {
    text-align: center;
    a {
      display: block;
    }
  }
}
</style>
